import React from 'react'
import styled from 'styled-components'
import SimpleReactLightbox from "simple-react-lightbox";
import { SRLWrapper } from "simple-react-lightbox";

const Image = styled.a`
    display: ${ props => props.display || "none" };
`

const Categorie = styled.p`
    width: max-content;
    padding: 0.2rem 0.5rem;
    margin: 0.8rem 0;
    border-radius: 0.5rem;
    background-color: ${ props => props.color || "cornflowerblue" };
    color: white;
`

const Title = styled.div`
    
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {

        width: 2rem!important;
        height: 2rem!important;
        margin-right: 0.8rem;
        
        &::last-child {
            margin-right: 0rem;
        }

    }

`

const Card = ({ color, app }) => {

    const getFullCategorie = ( categorie ) => {
        
        switch (categorie) {
            case "web": return "Web App"

            case "desktop": return "Desktop"

            case "mobile": return "Mobile"

            case "back": return "Backend"

            case "games": return "Game"
        
            default: return categorie.toUpperCase()
        }

    }

    return ( 

        <SimpleReactLightbox>

            <div className="entry tokyo_tm_portfolio_animation_wrap">

                <div className = "custom-parent">

                    <SRLWrapper>

                        {app.images.map(( image, index) => (
                            
                            <Image
                                key = { image + index }
                                href= { image }
                                display = { index === 0 ? "block" : "none" }
                            >
                                <img
                                    src={ image }
                                    alt= { `${app.name}` }
                                />
                            </Image>

                        ))}

                    </SRLWrapper>


                    <div className = "custom-layer">

                        <div className = "custom-child">

                            <Title>

                                <h6>{ app.name }</h6>

                                <div>

                                    { app.site && (
                                        <a href = { app.site } target = "_blank" rel="noopener noreferrer">
                                            <img
                                                className="svg"
                                                src={`/assets/img/svg/share.svg`}
                                                alt="social"
                                            />
                                        </a>
                                    )}

                                    { app.repo && (
                                        <a href = { app.repo } target = "_blank" rel="noopener noreferrer">
                                            <img
                                                className="svg"
                                                src={`/assets/img/svg/social/github.svg`}
                                                alt="social"
                                            />
                                        </a>
                                    )}

                                </div>

                            </Title>

                            <Categorie
                                color = { color }
                            >
                                { getFullCategorie( app.categorie ) }
                            </Categorie>

                            <p>
                                { app.description }
                            </p>
            
                            <p className = "custom-tec-title" >Technologies applied: </p>
            
                            {app.technologies.map(( tec, index ) => (
            
                                <p key = { index }>
                                    - { tec }
                                </p>
                            ))}
                        </div>

                    </div>

                </div>

            </div>

        </SimpleReactLightbox>
    );

}
 
export default Card;